import { render } from "./ColorPanel.vue?vue&type=template&id=61f696c3"
import script from "./ColorPanel.vue?vue&type=script&lang=js"
export * from "./ColorPanel.vue?vue&type=script&lang=js"

import "./ColorPanel.vue?vue&type=style&index=0&id=61f696c3&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__